
import { Component, Vue } from "vue-property-decorator";
import { MessageType } from "@/core/CommonDefinition";

@Component
export default class Message extends Vue {
  MessageType: any = MessageType;

  constructor() {
    super();
  }

  get getSnackbarColor(): string {
    const type: MessageType = this.$store.getters.getDisplayedMessage().type;
    if (type == MessageType.ERREUR) {
      return "erreur";
    } else if (type == MessageType.AVERTISSEMENT) {
      return "avertissement";
    } else if (type == MessageType.INFORMATION) {
      return "information";
    } else if (type == MessageType.VALIDATION) {
      return "validation";
    } else {
      return "information";
    }
  }

  get snackbarDisplayValue(): boolean {
    if (!this.$store.getters.getDisplayedMessage().isSticky) {
      setTimeout(() => {
        this.closeSnackBar();
      }, 6000); //TODO controler ici le delai du message
    }
    return this.$store.getters.getDisplayedMessage().isDisplayed;
  }

  get getSnackbarMultiline(): boolean {
    return this.$store.getters.getDisplayedMessage().isMultiline;
  }

  get getSnackbarText(): Array<string> {
    return this.$store.getters.getDisplayedMessage().texte.split("\n");
  }

  get getSnackbarType(): MessageType {
    return this.$store.getters.getDisplayedMessage().type;
  }

  /******************** Events ***************************/
  closeSnackBar(): void {
    this.$store.dispatch("closeDisplayedMessage");
  }
}
